import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '../../routes/routePaths';
import { supportFormURL } from '../../util/constants';

const Breadcrumb = () => {
  return (
    <div className="ao_mobMenu ms-auto">
      <div className="dropdown d-none d-md-block d-lg-none">

        <Dropdown align="end">
          <Dropdown.Toggle
            className="dropdown-toggle bg-transparent font-medium"
          >
            Menu
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="dropdown-menu dropdown-menu-end"
          >
            <li>
              <Link to={ROUTE_PATHS.CATEGORY_HOME} className="dropdown-item">
                Home
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  if (supportFormURL) {
                    window.open(supportFormURL, '_blank', 'location=no,height=980,width=880');
                  }
                }}
              >
                Support
              </Link>
            </li>
            <li>
              <Link
                to="https://www.aosphere.com"
                className="dropdown-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                More Services
              </Link>
            </li>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <ul className="d-md-none">
        <li>
          <Link to={ROUTE_PATHS.CATEGORY_HOME}>
            <img src="/assets/images/newdesign/home.svg" width="20" alt="Home" />
          </Link>
        </li>
        <li>
          <Link
            to="#"
            onClick={(event) => {
              event.preventDefault();
              if (supportFormURL) {
                window.open(supportFormURL, '_blank', 'location=no,height=980,width=880');
              }
            }}
          >
            Support
          </Link>
        </li>
        <li>
          <Link to="https://www.aosphere.com" target="_blank" rel="noreferrer">
            More Services
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
